<section id="summary" class="tw-pb-5">
  <!-- Widgets de tasas -->
  <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-5 md:tw-gap-3 tw-mb-6 tw-items-stretch tw-auto-rows-[minmax(240px,auto)]">
    <mh-surveys-summary-valid-data-rate
      [chainFilter]="chainFilter"
      [productId]="productId"
      [currentDates]="currentDates"
      [currentFilterDate]="currentFilterDate"
      [surveysReady]="surveysReady"
      [chain]="chain"
      [isHotel]="isHotel"
      (loadingChange)="onLoadingChange($event, 'validDataRate')">
    </mh-surveys-summary-valid-data-rate>

    <mh-surveys-summary-answers-rate
      [chainFilter]="chainFilter"
      [productId]="productId"
      [currentDates]="currentDates"
      [currentFilterDate]="currentFilterDate"
      [surveysReady]="surveysReady"
      [chain]="chain"
      [isSuperAdmin]="isSuperAdmin"
      (loadingChange)="onLoadingChange($event, 'answersRate')">
    </mh-surveys-summary-answers-rate>

    <mh-surveys-summary-nps
      [npsData]="npsData"
      [loading]="loadingNpsData">
    </mh-surveys-summary-nps>

    <mh-surveys-summary-average-rating
      [chainFilter]="chainFilter"
      [productId]="productId"
      [currentDates]="currentDates"
      [surveysReady]="surveysReady"
      (loadingChange)="onLoadingChange($event, 'averageRating')">
    </mh-surveys-summary-average-rating>

    <mh-surveys-summary-detractors-rate
      [npsData]="npsData"
      [loading]="loadingNpsData"
      [productId]="productId">
    </mh-surveys-summary-detractors-rate>
  </div>

  <mh-surveys-summary-semantic
    [chainFilter]="chainFilter"
    [productId]="productId"
    [currentDates]="currentDates"
    [surveysReady]="surveysReady"
    (loadingChange)="onLoadingChange($event, 'semanticIndex')">
  </mh-surveys-summary-semantic>

  <!-- Área de followup -->
  <div *ngIf="fidelityPermissions.includes('interchain_followup_summary_areas')" class="tw-w-full tw-bg-white tw-h-[100%] tw-p-5 tw-rounded-lg tw-shadow-b-md tw-shadow-md tw-shadow-t-md tw-shadow-tb">
    <mh-chain-followup-areas
      [currentDates]="currentDates"
      [productId]="productId"
      [chain]="chainFilter"
    ></mh-chain-followup-areas>
  </div>
</section>
